"use strict";
var immutable_1 = require('immutable');
var createLogger = require('redux-logger');
var logger = createLogger({
    level: 'info',
    collapsed: true,
    predicate: function (getState, action) { return __DEV__ === true; },
    stateTransformer: function (state) {
        var newState = {};
        for (var _i = 0, _a = Object.keys(state); _i < _a.length; _i++) {
            var i = _a[_i];
            if (immutable_1.Iterable.isIterable(state[i])) {
                newState[i] = state[i].toJS();
            }
            else {
                newState[i] = state[i];
            }
        }
        ;
        return newState;
    }
});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = logger;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlndXJlLWxvZ2dlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImNvbmZpZ3VyZS1sb2dnZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLDBCQUF5QixXQUFXLENBQUMsQ0FBQTtBQUNyQyxJQUFNLFlBQVksR0FBRyxPQUFPLENBQUMsY0FBYyxDQUFDLENBQUM7QUFFN0MsSUFBTSxNQUFNLEdBQUcsWUFBWSxDQUFDO0lBQ3hCLEtBQUssRUFBRSxNQUFNO0lBQ2IsU0FBUyxFQUFFLElBQUk7SUFDZixTQUFTLEVBQUUsVUFBQyxRQUFRLEVBQUUsTUFBTSxJQUFLLE9BQUEsT0FBTyxLQUFLLElBQUksRUFBaEIsQ0FBZ0I7SUFDakQsZ0JBQWdCLEVBQUUsVUFBQyxLQUFLO1FBQ3BCLElBQUksUUFBUSxHQUFHLEVBQUUsQ0FBQztRQUNsQixHQUFHLENBQUMsQ0FBVSxVQUFrQixFQUFsQixLQUFBLE1BQU0sQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLEVBQWxCLGNBQWtCLEVBQWxCLElBQWtCLENBQUM7WUFBNUIsSUFBSSxDQUFDLFNBQUE7WUFDTixFQUFFLENBQUMsQ0FBQyxvQkFBUSxDQUFDLFVBQVUsQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7Z0JBQ2hDLFFBQVEsQ0FBQyxDQUFDLENBQUMsR0FBRyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsSUFBSSxFQUFFLENBQUM7WUFDbEMsQ0FBQztZQUFDLElBQUksQ0FBQyxDQUFDO2dCQUNKLFFBQVEsQ0FBQyxDQUFDLENBQUMsR0FBRyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUM7WUFDM0IsQ0FBQztTQUNKO1FBQUEsQ0FBQztRQUNGLE1BQU0sQ0FBQyxRQUFRLENBQUM7SUFDcEIsQ0FBQztDQUNKLENBQUMsQ0FBQztBQUVIO2tCQUFlLE1BQU0sQ0FBQyJ9


/*****************
 ** WEBPACK FOOTER
 ** ./src/store/configure-logger.ts
 ** module id = 971
 ** module chunks = 1
 **/